import { getLocalizedString } from '../../../../../utils/get-localized-string.js';

function getLineItemCartDiscountDescription(lineItemRaw, locale) {
    const { discounts  } = lineItemRaw;
    if (!discounts || discounts.length === 0) {
        return;
    }
    const cartDiscounts = discounts === null || discounts === void 0 ? void 0 : discounts.filter((discount)=>discount.type === 'CartDiscount'
    );
    if (!cartDiscounts.length) {
        return;
    }
    return getLocalizedString(locale, cartDiscounts[0].description);
}

export { getLineItemCartDiscountDescription };
//# sourceMappingURL=get-line-item-cart-discount-description.js.map
